import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';

export function useToggleCategoryFavouriteMutation() {
  const queryClient = useQueryClient();

  const { mutateAsync: toggleFavourite, isLoading } = useMutation(
    ({ id, isFavourite }: { id: string; isFavourite: boolean }) =>
      isFavourite
        ? API_HANDLERS.CATEGORY.REMOVE_FAVOURITE(id)
        : API_HANDLERS.CATEGORY.ADD_FAVOURITE(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['document_categories']);
      },
    },
  );

  return { toggleFavourite, isLoading };
}
